<template>
  <div class="dashboard-meun-bind-dialog">
    <custom-dialog width="1200px" :title="model.title" :visible="visible"  v-on="$listeners" >
      <div class="dialog-body">
        <div class="title">
          <i class="icon icon-tishi"></i>
          <span>{{ $t('base_dashboard_meun_bind_dialog.zdkx10gcd') }}</span>
        </div>
        <div style="height: 44px">
          <el-radio-group v-model="appId" @change="onAppItem">
            <el-radio-button v-for="(item, index) in appList" :key="index" :label="item.appId">{{ item.appName }}</el-radio-button>
          </el-radio-group>
        </div>

        <div class="per-wrap">
          <!--             :defaultExpandAll="true"  row-key="appId" -->
          <custom-table
            tableCode="roleAuth"
            :index="true"
            :boderRight="true"

            v-loading="isLoading"

            @column="setColumn"
            :data="appMenu"
            height="600px"
            :slots="['menuFunList', 'menuFunListHeader']"
          >
            <template slot="menuFunListHeader" slot-scope="scope">
              <el-checkbox v-model="isCheckAll" :indeterminate="!!indeterminate" @change="onCheckAll">
                <span style="font-weight: bold">{{ scope.column.label }}</span>
              </el-checkbox>
            </template>
            <template slot="menuFunList" slot-scope="scope">
              <div class="ub">


                <div class="checkall" v-if="scope.row.children">
                  <el-checkbox :indeterminate="!!scope.row.indeterminate"  v-model="scope.row.checkedAll" @change="checkAllChange($event, scope.row.children, scope.row)">
                    {{ $t('Common.com_sel_all') }}
                  </el-checkbox>
                </div>
                <div class="ub-f1 func-list-box" v-if="scope.row.children">
                  <div class="ub">
                    <!-- <div class="checkall" v-if="name != 'default'" style="margin-right: 12px; color: #98a6ad">
                        {{arr.menuName }}
                    </div> -->
                    <div class="ub-f1" style="flex-wrap: wrap; display: flex" >
                      <el-checkbox v-for="item in scope.row.children"  @change="checkChange($event, scope.row.children, scope.row)" :key="item.menuId" v-model="item.checked">{{ item.menuName }}</el-checkbox>
                    </div>
                  </div>
                </div>

                <div class="checkall" v-else>
                  <el-checkbox  v-model="scope.row.checked" @change="checkAllChange($event, scope.row.children, scope.row)">
                    {{ $t('Common.com_sel_all') }}
                  </el-checkbox>
                </div>
              </div>
            </template>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveRolePer()">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>

  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      appId: '',
      appList: [],
      appMenuTree: [], // 未赋值
      appMenuCache: {},
      appMenu: [], // 赋值后
      isLoading: false,
      isCheckAll: false,
      indeterminate: false,
    };
  },
  // props: {

  //   orgId: [String, Number],
  // },
  // watch: {
  //   roleId: function () {
  //     this.appMenu = [];
  //     this.getAppMenu();
  //   },
  // },
  // computed: {
  //   isSubmit: vm => vm.getCheckedFuncId().length > 0
  // },
  mounted() {
    this.getAppList();
  },
  methods: {
    // 获取应用列表
    getAppList: function (lang) {
      this.$getJSON(apis.AppList, { orgId: this.orgId }).then((res) => {
        this.appList = res.data.filter(item => item.appCode !== 'app' && item.appCode !== 'custom_app' && item.appCode !== 'customer-portal'); // 应用列表            ;
        if (!lang) {
          const app = this.appList[0] ? this.appList[0] : {};
          this.appId = app.appId;
          this.getAppMenu();
        }
      });
    },
    // 选择应用
    onAppItem: function (item) {
      this.appId = item;
      this.getAppMenu();
    },
    // 获取应用菜单树
    getAppMenu: function () {
      const appId = JSON.parse(JSON.stringify(this.appId)); // 不能直接使用this.appId,因为这个值可能中途修改导致赋值错误
      if (!appId) {
        return;
      }
      if (this.appMenuCache[appId]) {
        this.appMenuTree = this.appMenuCache[appId];
        this.getRolePerList();
        return;
      }
      this.isLoading = true;
      this.$getJSON(apis.AppMenuTree, { appId: appId, orgId: this.orgId }).then((res) => {
        this.isLoading = false;
        const filteredTree = res.data.filter(item => item.showWay === 1);
        filteredTree.forEach((item) => {
          if (item.children && item.children.length) {
            item.children = item.children.filter(fitem => fitem.showWay === 1);
            item.children.forEach((items) => {
              // 删除当前菜单项的 funList 字段（如果存在）
              if (items.hasOwnProperty('funList')) {
                delete items.funList; // 只删除存在的 funList 字段
              }
            });
          }
          // 删除当前菜单项的 funList 字段（如果存在）
          if (item.hasOwnProperty('funList')) {
            delete item.funList; // 只删除存在的 funList 字段
          }
        });
        this.appMenuTree = filteredTree || [];
        this.appMenuCache[appId] = filteredTree || []; // 缓存
        this.getRolePerList();
      });
    },
    // 获取角色权限
    getRolePerList: function () {
      if (!this.appId) {
        this.mergeTree([]);
        return;
      }
      this.isLoading = true;
      this.$getJSON(apis.favoriteQueryMenu).then((res) => {
        // 赋值
        this.isLoading = false;
        const list = res.data.map(t => t.menuId);
        this.mergeTree(list);
        this.computedAll();
      });
    },
    // 设置岗位选中状态
    mergeTree: function (list) {

      const tree = JSON.parse(JSON.stringify(this.appMenuTree));
      tree.forEach((item) => {
        if (item.children && item.children.length) {
          item.children.forEach((items) => {

            items.checked = !!list.includes(items.menuId);
            const len = item.children.filter(t => t.checked).length;
            item.checkedAll = item.children.length === len;
            item.indeterminate = !item.checkedAll && len;
          });
        } else {
          item.checked = !!list.includes(item.menuId);
          // item.checkedAll = item.checked;
          // item.indeterminate = !item.checkedAll;
        }
      });
      this.appMenu = tree;
    },
    // 全局全选事件
    onCheckAll: function (val) {
      this.indeterminate = false;
      if (!val) {
        this.mergeTree([]);
        return;
      }
      const menuIds = this.getAllFuncId();
      this.mergeTree(menuIds);
    },
    // 获取选中funcId
    getCheckedFuncId: function () {
      let list = [];
      this.appMenu.forEach((item) => {

        if (item.children && item.children.length) {
          const checkeds = item.children.filter(t => t.checked);
          list = [...list, ...checkeds];
        } else if (item.checked) {
          const checkeds = item;
          list.push(checkeds);
        }

      });
      list = list.map(t => t.menuId);
      return list;
    },
    // 获取全部funcId
    getAllFuncId: function () {
      let list = [];
      this.appMenu.forEach((item) => {
        if (item.children && item.children.length) {
          const checkeds = item.children;
          list = [...list, ...checkeds];
        } else {
          const checkeds = item;
          list.push(checkeds);
        }

      });

      list = list.map(t => t.menuId);
      return list;
    },
    // 计算全局全选
    computedAll: function () {
      const menuIds = this.getAllFuncId();
      const list = this.getCheckedFuncId();
      this.isCheckAll = list.length === menuIds.length;
      this.indeterminate = list.length && list.length !== menuIds.length;
    },
    // 局部全选事件
    checkAllChange: function (value, list, row) {
      if (!list) {
        row.checked = value;
        row.indeterminate = false;
        this.computedAll();
        return;
      }
      list.forEach((item) => {
        item.checked = value;
      });
      row.indeterminate = false;
      this.computedAll();
    },
    // 权限单选事件
    checkChange: function (value, row, list) {
      const len = row.filter(t => t.checked).length;
      list.checkedAll = row.length === len;
      list.indeterminate = !row.checkedAll && len;
      this.computedAll();
    },
    // 保存权限
    saveRolePer: function () {
      const menuIds = this.getCheckedFuncId();
      const params = {
        appId: this.appId,
        menuIds: menuIds,
      };
      this.$postJSON(apis.favoriteAdd, params, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.dashboard-meun-bind-dialog {
  .per-wrap {
    flex: 1;
    overflow: hidden;
    .el-checkbox__label {
      color: #6c757d;
      line-height: 23px;
      font-weight: normal;
      font-size: 12px;
    }
    .checkall {
      display: flex;
      align-items: center;
      padding-right: 15px;
      margin-right: 15px;
      position: relative;
      min-width: 132px;
      &::before {
        content: '';
        position: absolute;
        right: 0;
        top: 2px;
        bottom: 2px;
        width: 1px;
        background-color: #eef2fa;
      }
    }
    .func-list-box {
      & > div {
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: 1px dotted #eef2fa;
        &:last-child {
          padding-bottom: 0;
          margin-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }
  .title {
          padding-left: 10px;
          background: rgba(249, 200, 81, 0.15);
          border-radius: 2px;
          font-size: 12px;
          line-height: 32px;
          color: rgba(108, 117, 125, 1);
          margin-bottom: 12px;
          .icon {
            color: rgba(249, 200, 81, 1);
            margin-right: 10px;
          }
        }
}
</style>
